<div class="icon-grid">
  @if (isTeacherOrEducatorStaffMember) {
    <div class="tile" matTooltip="Présences par classe">
      <a routerLink="admin/students/justificationsByClass" data-cy="go-to-justifications-by-class-page">
        <mat-icon inline>how_to_reg</mat-icon>
      </a>
    </div>
  }
  @if (isTeacherStaffMember) {
    <div class="tile" matTooltip="Planning">
      <a routerLink="admin/planning" data-cy="go-to-planning-page">
        <mat-icon inline>calendar_today</mat-icon>
      </a>
    </div>
  }
  @if (isStaffMember) {
    <div class="tile" matTooltip="Remarques élèves">
      <a routerLink="admin/students/remarks" data-cy="go-to-remarks-page">
        <mat-icon inline>announcement</mat-icon>
      </a>
    </div>
  }
  @if (isStaffMember) {
    <div class="tile" matTooltip="Liste des élèves">
      <a routerLink="admin/students/list" data-cy="go-to-student-list-page">
        <mat-icon inline>groups</mat-icon>
      </a>
    </div>
  }
  @if (isTeacherStaffMember) {
    <div class="tile" matTooltip="Gestion des évaluations">
      <a routerLink="admin/score-book/evaluations" data-cy="go-to-evaluation-page">
        <mat-icon inline>menu_book</mat-icon>
      </a>
    </div>
  }
  @if (isStaffMember) {
    <div class="tile" matTooltip="Bulletins">
      <a routerLink="admin/school-report/consult" data-cy="go-to-report-consult-page">
        <mat-icon inline>description</mat-icon>
      </a>
    </div>
  }
</div>
